package tools

import androidx.compose.runtime.*
import io.*
import org.jetbrains.compose.resources.*
import provider.*

// stringResource(transform(), formatArgs).trimIndent()
@Composable
fun StringResource.rememberString(vararg formatArgs: Any): String {
    val lang = LocalLocalization.current.language
    var result by remember(key) {
        mutableStateOf("")
    }
    LaunchedEffect(lang, key, formatArgs) {
        result = Repository.strings.get(key, formatArgs.toList())
    }
    return result
}

@Composable
fun StringResource.rememberString(): String {
    val lang = LocalLocalization.current.language

    var result by remember(key) {
        mutableStateOf("")
    }
    LaunchedEffect(lang, key) {
        result = Repository.strings.get(key)
    }
    return result
}

suspend fun StringResource.await(vararg formatArgs: Any) = Repository.strings.get(key, formatArgs.toList())

suspend fun StringResource.await() = Repository.strings.get(key)
